
import Loading from '@/components/chat/loding.vue';
import PostComponent from '@/components/posts/PostComponent.vue';
import { mapGetters } from 'vuex'
export default {
  name: 'SectionPosts',
  components: {
    PostComponent,
    Loading
  },
  props: {
    menuIndex: {
      type: Number,
      default: 1,
    },
    categoryItems: {
      type: Array,
      default: () => []
    },
    tagColor: {
      type: String,
      default: '#00B0E9'
    }
  },
  computed: {
    styleObject() {
      return {
        '--menu-color': this.tagColor
      }
    },
    category() {
      return this.categoryItems[this.menuIndex].title;
    }
  },
  watch: {
    menuIndex: {
      handler(index) {
        if (index == 1) {
          this.form.district_id = 0;
        }
        if (index == 2) {
          this.form.district_id = this.$store.state.district.id;
        }
        this.form.page = 0;
        this.getPosts();
      },
      immediate: true
    }
  },
  data() {
    return {
      loading: false,
      postList: [],
      postLinks: {},
      postMeta: {},
      form: {
        board: '',
        page: 0,
        district_id: this.$store.state.district.id,
        word: this.$route.query.word ?? '',
      }
    }
  },
  methods: {
    async getPosts() {
      const response = await this.$axios.get('/api/posts', {
        params: this.form,
      });
      this.postList = response.data.data;
      this.postLinks = response.data.links;
      this.postMeta = response.data.meta;
      this.loading = false;
    },
    async loadMore() {
      if (this.postMeta.current_page <= this.postMeta.last_page) {
        this.form.page = this.postMeta.current_page + 1;
        const response = await this.$axios.get('/api/posts', {
          params: this.form
        });
        this.postList = [...this.postList, ...response.data.data];
        this.postLinks = response.data.links;
        this.postMeta = response.data.meta;
      }
    }
  },
  mounted() {
    this.loading = true;
    // this.getPosts();
  },
}
